import { DATA_STATUS } from '@/constants';
import * as dataSelectors from '@/data/data-selectors';
import { useSelector } from 'react-redux';

export function useLicenses() {
  const licenses = useSelector(dataSelectors.licensesData);
  const loading = !licenses || licenses === DATA_STATUS.inProgress;
  const error = licenses === DATA_STATUS.dataError;

  const propertyDetailsTabs = useSelector(dataSelectors.propertyDetailsTabs);
  const isEnabled = propertyDetailsTabs?.license?.enabled;
  return { licenses, loading, error, isEnabled };
}
